<router-outlet></router-outlet>
<p-toast key="global"></p-toast>
<app-timeout *ngIf="timeoutActive"></app-timeout>
